// src/pages/CompleteProfile.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import RoleSelector from "../components/RoleSelector";

export default function CompleteProfile() {
  const { currentUser, completeOnboarding, logout } = useAuth();
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [orgName, setOrgName] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (!role) {
      setError("Please choose whether you’re a Startup or a Business Owner.");
      return;
    }
    if (!orgName.trim()) {
      setError("Please enter your organization name.");
      return;
    }
    setSaving(true);
    try {
      await completeOnboarding({ role, orgName: orgName.trim() });
      navigate("/", { replace: true });
    } catch (err) {
      setError(err?.message || "Couldn’t finish setup. Please try again.");
      setSaving(false);
    }
  }

  async function handleUseDifferentAccount() {
    await logout();
    navigate("/signup", { replace: true });
  }

  const orgLabel = role === "corporation" ? "Company name" : role === "startup" ? "Startup name" : "Organization name";
  const orgPlaceholder = role === "corporation" ? "Acme Corp" : role === "startup" ? "My Startup Inc" : "Your organization";

  return (
    <div className="auth-page">
      <div className="auth-page-inner">
        <div className="auth-page-header">
          <p className="auth-step-eyebrow">Almost there</p>
          <h1>How will you use Mana Tech Access?</h1>
          <p>
            {currentUser?.email
              ? `Signed in as ${currentUser.email}. Choose your account type to finish setup.`
              : "Choose your account type to finish setup."}
          </p>
        </div>

        <div className="card auth-card">
          <form onSubmit={handleSubmit} className="complete-profile-form" noValidate>
            <div className="form-group">
              <label className="form-label" id="role-label">
                I am a… <span className="form-required">*</span>
              </label>
              <RoleSelector value={role} onChange={setRole} />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="org-name">
                {orgLabel} <span className="form-required">*</span>
              </label>
              <input
                id="org-name"
                className="input"
                value={orgName}
                onChange={e => setOrgName(e.target.value)}
                placeholder={orgPlaceholder}
                autoComplete="organization"
                required
                disabled={!role}
                style={{ minHeight: 44 }}
              />
              {!role && (
                <p className="form-hint">Select an account type first</p>
              )}
            </div>

            {error && (
              <div className="form-error" role="alert" style={{
                padding: "10px 12px",
                background: "rgba(220,80,60,0.1)",
                borderRadius: "var(--radius)",
                border: "1px solid rgba(220,80,60,0.2)"
              }}>
                {error}
              </div>
            )}

            <button
              className="btn btn-primary"
              type="submit"
              disabled={saving || !role || !orgName.trim()}
              style={{ justifyContent: "center", padding: "12px", minHeight: 48, width: "100%" }}
            >
              {saving ? <span className="spinner" style={{ width: 16, height: 16 }} /> : "Continue to dashboard →"}
            </button>
          </form>

          <button
            type="button"
            className="auth-secondary-link"
            onClick={handleUseDifferentAccount}
            disabled={saving}
          >
            Use a different account
          </button>
        </div>
      </div>
    </div>
  );
}
